<template>
  <div>
    <b-form @submit.prevent="onSaveProfile">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Nome do Perfil">
            <b-form-input
              v-model="role.name"
              placeholder="Digite o nome do perfil"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-card header="Módulos" class="mb-3">
        <b-row>
          <b-col cols="12" md="6" class="mb-3">
            <b-form-group label="Usuários">
              <b-form-checkbox v-model="role.permissions.user.read"
                >Ver</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.user.create"
                >Criar</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.user.edit"
                >Editar</b-form-checkbox
              >
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-3">
            <b-form-group label="Empresa">
              <b-form-checkbox v-model="role.permissions.company.read"
                >Ver</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.company.edit"
                >Editar</b-form-checkbox
              >
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-3">
            <b-form-group label="Questionários">
              <b-form-checkbox v-model="role.permissions.questionnaire.read"
                >Ver</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.questionnaire.create"
                >Criar</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.questionnaire.edit"
                >Editar</b-form-checkbox
              >
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-3">
            <b-form-group label="Denúncias">
              <b-form-checkbox v-model="role.permissions.complaint.read"
                >Ver</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.complaint.readall"
                >Ver tudo</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.complaint.edit"
                >Editar</b-form-checkbox
              >
              <b-form-checkbox
                v-model="role.permissions.complaint.managedByJoinCommittee"
                >Participar do comitê das empresas gerenciadas</b-form-checkbox
              >
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-3">
            <b-form-group label="Menções">
              <b-form-checkbox v-model="role.permissions.mention.read"
                >Ver</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.mention.edit"
                >Editar</b-form-checkbox
              >
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-3">
            <b-form-group label="Dúvidas e Sugestões">
              <b-form-checkbox v-model="role.permissions.qas.read"
                >Ver</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.qas.edit"
                >Editar</b-form-checkbox
              >
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-3">
            <b-form-group label="LGPD">
              <b-form-checkbox v-model="role.permissions.dsar.read"
                >Ver</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.dsar.edit"
                >Editar</b-form-checkbox
              >
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-3">
            <b-form-group label="Ouvidoria">
              <b-form-checkbox v-model="role.permissions.ombudsman.read"
                >Ver</b-form-checkbox
              >
              <b-form-checkbox v-model="role.permissions.ombudsman.edit"
                >Editar</b-form-checkbox
              >
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-3">
            <b-form-group label="Relatórios">
              <b-form-checkbox v-model="role.permissions.reports.read"
                >Ver</b-form-checkbox
              >
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card header="Relatórios" class="mb-3">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Denúncia">
              <b-form-checkbox
                v-model="role.permissions.reports.complaint.complaint"
                >Denúncia</b-form-checkbox
              >
              <b-form-checkbox
                v-model="role.permissions.reports.complaint.processing"
                >Processamento</b-form-checkbox
              >
              <b-form-checkbox
                v-model="role.permissions.reports.complaint.committee"
                >Comitê</b-form-checkbox
              >
              <b-form-checkbox
                v-model="role.permissions.reports.complaint.audit"
                >Auditoria</b-form-checkbox
              >
              <b-form-checkbox
                v-model="role.permissions.reports.complaint.readall"
                >Ver Tudo</b-form-checkbox
              >
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <div class="d-flex justify-content-end">
        <b-button variant="secondary" class="mr-2" @click="onCancel">
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          :disabled="loading || !role.name"
        >
          <b-spinner v-if="loading" small class="mr-1"></b-spinner>
          Salvar
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { getCompany, getCompanyRole, editRole, newRole } from "@/api/company";

function createIfNull(obj, key, value = {}) {
  obj[key] = obj[key] || value;
}

export default {
  name: "AccessProfileForm",
  props: {
    companyId: {
      type: [Number, String],
      required: true,
    },
    profileId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      company: {},
      loading: false,
      editing: false,
      role: {
        name: "",
        permissions: {
          user: {},
          company: {},
          questionnaire: {},
          complaint: {},
          mention: {},
          qas: {},
          dsar: {},
          ombudsman: {},
          reports: {
            complaint: {},
          },
        },
      },
    };
  },
  async created() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const response = await getCompany(this.companyId);
        this.company = response.data;

        let role = {};

        if (this.profileId) {
          const roleResponse = await getCompanyRole(
            this.companyId,
            this.profileId
          );
          role = roleResponse.data;
          this.editing = true;
        }

        createIfNull(role, "permissions");
        createIfNull(role.permissions, "user");
        createIfNull(role.permissions, "company");
        createIfNull(role.permissions, "questionnaire");
        createIfNull(role.permissions, "complaint");
        createIfNull(role.permissions, "mention");
        createIfNull(role.permissions, "qas");
        createIfNull(role.permissions, "dsar");
        createIfNull(role.permissions, "ombudsman");
        createIfNull(role.permissions, "reports");
        createIfNull(role.permissions.reports, "complaint");

        this.role = role;
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
        this.$bvToast.toast("Erro ao carregar dados do perfil", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },

    async onSaveProfile() {
      if (!this.role.name.trim()) {
        this.$bvToast.toast("O nome do perfil é obrigatório", {
          title: "Atenção",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.loading = true;

      try {
        const action = this.editing ? editRole : newRole;
        await action(this.companyId, this.role);

        this.$emit("saved");
      } catch (error) {
        console.error("Erro ao salvar perfil:", error);
        this.$bvToast.toast("Erro ao salvar perfil de acesso", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },

    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
::v-deep .card-header {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
}

::v-deep .form-group label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
}

::v-deep .custom-checkbox {
  margin-bottom: 0.5rem;
}
</style>
